import React from "react";

// Nature-inspired mark: a leaf/pine emblem in gold on forest green.
export function LogoMark({ size = 40, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}
         xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="24" cy="24" r="23" stroke="#C5A059" strokeWidth="1.5" />
      <path d="M24 8C24 8 15 15 15 26c0 6 4 10 9 10s9-4 9-10C33 15 24 8 24 8Z"
            fill="#C5A059" fillOpacity="0.16" stroke="#C5A059" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M24 12v26" stroke="#C5A059" strokeWidth="1.4" strokeLinecap="round" />
      <path d="M24 20l-5-4M24 26l5-4M24 32l-5-4" stroke="#C5A059" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  );
}

export function Logo({ dark = false, size = 40, subtitle = true }) {
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <LogoMark size={size} />
      <div className="leading-tight">
        <div className={`font-display text-xl font-semibold tracking-tight ${dark ? "text-forest-deep" : "text-white"}`}>
          Върбица
        </div>
        {subtitle && (
          <div className={`text-[10px] uppercase tracking-[0.25em] ${dark ? "text-gold-dark" : "text-gold-light"}`}>
            Хотел &amp; Ресторант
          </div>
        )}
      </div>
    </div>
  );
}
